import { makeHttpClient, _unwrapAxiosResponse } from "./http";

import env from "../environment/env.json";
import { identity } from "rxjs";

export class CountrySupportOverViewDataService {
  private httpClient = makeHttpClient();
  //please config env as well
  getCountryListData(query: any) {
    let url = env.countrySupportOverview;
    if (query) {
      url = url + "?" + query;
    }
    return _unwrapAxiosResponse(
      this.httpClient.get<CountrySupportOverViewDataService>(url)
    );
  }

  get(id: string) {
    return _unwrapAxiosResponse(
      this.httpClient.get(`${env.countrySupportOverview}${id}/`)
    );
  }

  update(form: any) {
    const data = {
      country_id: form.country_id,
      streams: form.streams,
      reporting_responsible_id: form.reporting_responsible_id,
      id: form.id
    };
    return _unwrapAxiosResponse(
      this.httpClient.put<CountrySupportOverViewDataService>(
        `${env.countrySupportOverview}${form.id}`,
        data
      )
    );
  }

  delete(data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.delete<CountrySupportOverViewDataService>(
        `${env.countrySupportOverview}${data.id}`
      )
    );
  }

  create(form: any) {
    const data = {
      country_id: form.country_id,
      streams: form.streams,
      reporting_responsible_id: form.reporting_responsible_id
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<CountrySupportOverViewDataService>(
        env.countrySupportOverview,
        data
      )
    );
  }
}

export default CountrySupportOverViewDataService;
